const CLEAR_FILTERS = "CLEAR_FILTERS";
const RATING = "RATING";
const MEN = "MEN";
const WOMEN = "WOMEN";
const FREE_DELIVERY = "FREE_DELIVERY";
const SORT = "SORT";
const IN_STOCK = "IN_STOCK";

export { CLEAR_FILTERS, RATING, MEN, WOMEN, FREE_DELIVERY, SORT, IN_STOCK };
